import { graphql } from '@/generated/gql';

export const FILES_DEMAND_CREATE_MUTATION = graphql(/* GraphQL */ `
  mutation TesseractDemandDocumentCreate($id: UUID!, $data: [TsrctFileInput!]!) {
    tesseract {
      demand(id: $id) {
        file {
          create(data: $data) {
            id
            isSharedWithSupplier
            quoteId
            negotiationCaseId
            negotiationCaseSequence
          }
        }
      }
    }
  }
`);
